import { render } from "./MovieFilters.vue?vue&type=template&id=e4e12cc2&scoped=true"
import script from "./MovieFilters.vue?vue&type=script&lang=js"
export * from "./MovieFilters.vue?vue&type=script&lang=js"

import "./MovieFilters.vue?vue&type=style&index=0&id=e4e12cc2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e12cc2"]])

export default __exports__